import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {PulseLoader} from 'react-spinners';

class ImageContainer extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: this.props.loadingImage || false,
        }
    }

    showSpinner() {
        return (
            <div className='align-center sweet-loading'>
                <PulseLoader
                    color={'#003B71'}
                    loading={this.state.loading}
                />
            </div>
        );
    }

    render() {
        return (
            <div className={`image-container ${this.props.divClass}`} style={{height: this.props.height}}>              {this.showSpinner()}
                <img
                    src={this.props.image}
                    alt={this.props.name}
                    className="responsive-img"
                    style={!this.state.loading ? {} : {display: "none"}}
                    onLoad={() => {return this.setState({loading: false})}}
                />
            </div>
        );
    }

}

ImageContainer.propTypes = {
    name:   PropTypes.string,
    image:  PropTypes.string,
    height: PropTypes.string,
}


export default ImageContainer;



// WEBPACK FOOTER //
// ./src/components/image-handler/ImageContainer.js